const Checkboxes = {
  baseStyle: {
    label: {
      color: "white",
      fontFamily: "body",
    },
  },
  variants: {
    standard: {
      control: {
        borderColor: "Primary.500",
        bg: "white",
        _checked: {
          bg: "Primary.500",
          borderColor: "Primary.500",
          _hover: {
            bg: "Primary.300",
            borderColor: "Primary.500",
          },
        },
        _hover: {
          bg: "Primary.300",
        },
        _disabled: {
          color: "Gray.900",
          borderColor: "Gray.300",
        },
      },
    },
  },
}

export default Checkboxes
